<template>
  <v-app class="grey lighten-3">
    <v-layout>
      <v-flex xs12 sm12 md12>
        <v-container grid-list-md>
          <v-card>
            <!-- start location -->
            <v-card-title class="project">
              <div class="black--text headline">
                <span>Project's Responses</span>
              </div>
            </v-card-title>
            <v-card-text v-if="isLoaded">
              <v-data-table
                :headers="getColumns()"
                :items="indexData.datas"
                class="elevation-1"
              >
                <template slot="headerCell" slot-scope="props">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <span v-on="on">
                        {{ props.header.text }}
                      </span>
                    </template>
                    <span>
                      {{ getQuestion(props.header.text) }}
                    </span>
                  </v-tooltip>
                </template>
                <template v-slot:items="props">
                  <td>{{ props.item.project_id }}</td>
                  <td>{{ props.item.dasher_id }}</td>
                  <td>{{ props.item.created_at }}</td>

                  <td v-for="(coldata, index) in indexData.tcol" :key="index">
                    {{ getDataForView(props.item, coldata, index) }}
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-container>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapGetters } from "vuex";

  export default {
    data: () => ({
      dialog: false,
      alertMsg: false,
      apiUrl: "project-response",
      ProjectId: 1,
      sl: 1,
      loading: false,
      search: "",
      pagination: {},
      rowsPerPageItems: [5, 10, 20, 50, 100, 200, 500],
      editedIndex: -1,
      editedItem: {},
      defaultItem: {},
    }),

    computed: {
      ...mapGetters([
        "isLoggedIn",
        "indexData",
        "error",
        "statusCode",
        "errorMsg",
      ]),
      isLoaded() {
        if (this.indexData.datas) {
          return true;
        } else {
          return false;
        }
      },
    },

    watch: {
      // pagination() {
      //   this.onPageChange()
      // },
      dialog(val) {
        val || this.close();
      },
    },

    created() {
      this.initialize();
    },

    methods: {
      initialize() {
        this.ProjectId = JSON.parse(
          localStorage.getItem("project_details_by_id1")
        );
        this.$store.dispatch("getProjectReportResponse", [
          this.ProjectId,
          this.apiUrl,
          "responseData",
        ]);
      },
      getQuestion: function (variablData) {
        var question_name = "";
        // console.log(this.indexData.questions);
        var found = this.indexData.questions.find(
          (questionObj) => questionObj.question_variable === variablData
        );
        question_name = found ? found.question : variablData;
        return question_name;
      },
      getDataForView: function (passData, coldata, index) {
        const arrayFailed = Object.entries(passData).map((arr) => ({
          key: arr[0],
          value: arr[1],
        }));
        var mayData = "";
        arrayFailed.filter(function (elem) {
          if (elem.key == coldata) {
            mayData = elem.value;
          }
        });
        let ui_category_id = this.indexData.questions[index].ui_category_id;

        if (
          (ui_category_id == 1 || ui_category_id == 2 || ui_category_id == 4) &&
          (this.getLanguage() == 1 || this.getLanguage() == 3)
        ) {
          // console.log(this.indexData.questions[index].options);
          this.indexData.questions[index].options.forEach((element) => {
            if (element.value == mayData) {
              mayData = element.title;
            }
          });
        } else if (
          (ui_category_id == 1 || ui_category_id == 2 || ui_category_id == 4) &&
          (this.getLanguage() == 2 || this.getLanguage() == 3)
        ) {
          this.indexData.questions[index].bangla_options.forEach((element) => {
            if (element.value == mayData) {
              mayData = element.title;
            }
          });
        } else if (ui_category_id == 14) {
          this.indexData.questions[index].image_options.forEach((element) => {
            if (element.value == mayData) {
              mayData = element.title;
            }
          });
        }
        return mayData;
      },
      getLanguage() {
        return this.indexData.projectInfo.project_language;
      },
      getColumns() {
        var columnsData = [
          { text: "Project Id", align: "left", value: "id" },
          { text: "Dasher ID", align: "left", value: "name" },
          { text: "Submitted At", align: "left", value: "created_at" },
        ];
        if (this.indexData.questions) {
          this.indexData.questions.forEach((value) => {
            columnsData.push({
              text: value.question_variable,
              align: "left",
              sortable: false,
              value: value.question_variable,
            });
          });
        }
        return columnsData;
      },
      setErrorZero() {
        this.$store.dispatch("setErrorZero");
      },

      // checkItemReport (projectId) {
      //   this.$store.dispatch('getProjectReportDetails',[ projectId, this.apiUrl])
      // },

      close() {
        this.dialog = false;
        setTimeout(() => {
          this.editedItem = Object.assign({}, this.defaultItem);
          this.editedIndex = -1;
        }, 300);
      },

      // onPageChange(){
      //   this.paginationMethod()
      // },
    },
  };
</script>
<style lang="stylus" scoped>
  .v-progress-circular
    margin: 1rem

  .imageResize
    width: auto
    height: auto
</style>
